module.exports = __webpack_public_path__ + "images/chatse97a6acaccfb9257574e0779095e0341.png";